import { render, staticRenderFns } from "./bankListsDc.vue?vue&type=template&id=8dbc3fb8"
import script from "./bankListsDc.vue?vue&type=script&lang=js"
export * from "./bankListsDc.vue?vue&type=script&lang=js"
import style0 from "./bankListsDc.vue?vue&type=style&index=0&id=8dbc3fb8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports